module.exports = __webpack_public_path__ + "content/ffdcb9d9d189b939b750ad1399df1cb9.png";